import { ApolloProvider } from '@apollo/client/react/context/ApolloProvider'
import { datadogLogs } from '@datadog/browser-logs'
import { ThemeProvider } from '@focaldata/cin-ui-components'
import { StyledEngineProvider } from '@mui/material/styles'
import { Provider } from 'react-redux'
import { Route, Routes } from 'react-router-dom'
import { store } from './App.store'
import client from './apollo/apolloClient'
import RefreshTokenWrapper from './components/Auth/RefreshTokenWrapper'
import StagingInfoBanner from './components/StagingInfoBanner/StagingInfoBanner'
import AccountSwitcher from './containers/AccountSwitcher'
import CreatePassword from './containers/Auth/CreatePassword'
import ForgotPasswordComponent from './containers/Auth/ForgotPassword'
import ForgotPasswordSuccessful from './containers/Auth/ForgotPassword/ForgotPasswordSuccessful'
import ResetPasswordContainer from './containers/Auth/ForgotPassword/ResetPassword'
import LoginComponent from './containers/Auth/Login'
import SignupComponent from './containers/Auth/Signup'
import SignupSuccessful from './containers/Auth/SignupSuccessful'
import Page from './containers/Page'
import TermsAndConditions from './controls/TermsAndConditions'
import PublicResultsPage from './modules/PublicResults/PublicResultsPage/PublicResultsPage.container'
import { DATADOG_VERSION } from './tracking/datadog'
import { getEnvironment } from './utils/HelperFunctions'

const isProd = window.location.hostname.endsWith('.com')
const preProdBranch = process.env.REACT_APP_PRE_PROD_BRANCH
const latestReleaseVersion = process.env.REACT_APP_RELEASED_VERSION

const initDatadogLogs = () => {
  datadogLogs.init({
    clientToken: 'pub27dfa604d21952c62a0c260c5e499967',
    site: 'datadoghq.eu',
    service: 'cin-fd-surveys',
    forwardErrorsToLogs: false,
    env: getEnvironment(),
    version: DATADOG_VERSION,
    sessionSampleRate: 100
  })
}

const App = () => {
  initDatadogLogs()

  return (
    <Provider store={store}>
      <div className="App">
        {!isProd && !!preProdBranch && !!latestReleaseVersion && (
          <StagingInfoBanner
            branch={preProdBranch}
            version={latestReleaseVersion}
          />
        )}
        <ApolloProvider client={client}>
          <ThemeProvider>
            <StyledEngineProvider injectFirst>
              <Routes>
                <Route path="/login" element={<LoginComponent />} />
                <Route path="/signup">
                  <Route index element={<SignupComponent />} />
                  <Route path=":iid" element={<SignupComponent />} />
                  <Route path=":auto-signup" element={<SignupComponent />} />
                </Route>
                <Route
                  path="/forgot-password"
                  element={<ForgotPasswordComponent />}
                />
                <Route path="/forgot-password-successful">
                  <Route index element={<ForgotPasswordSuccessful />} />
                  <Route path=":email" element={<ForgotPasswordSuccessful />} />
                </Route>
                <Route
                  path="/success-message/:email/:requestId"
                  element={<SignupSuccessful />}
                />
                <Route
                  path="/create-password/:requestId"
                  element={<CreatePassword />}
                />
                <Route path="/reset-password">
                  <Route index element={<ResetPasswordContainer />} />
                  <Route path=":rid" element={<ResetPasswordContainer />} />
                </Route>
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route
                  path="/public/:surveyId"
                  element={<PublicResultsPage />}
                />
                <Route path="/account-switcher" element={<AccountSwitcher />} />

                <Route
                  path="*"
                  element={
                    <RefreshTokenWrapper>
                      <Page />
                    </RefreshTokenWrapper>
                  }
                />
              </Routes>
            </StyledEngineProvider>
          </ThemeProvider>
        </ApolloProvider>
      </div>
    </Provider>
  )
}

export default App
